import React, { useRef, useEffect, useMemo } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import * as AlertReducer from "../../store/ducks/AlertReducer";
import * as SoundReducer from "../../store/ducks/SoundReducer";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function CustomSnackbar() {
  const classes = useStyles();
  const dispatch = useDispatch();

  // Load alert data from the Redux store
  const { alert, sound, user } = useSelector((state) => ({
    alert: state.alert,
    sound: state.sound,
    user: state.auth.user,
  }));

  
  const sounds = useMemo(
    () => ({
      sound_notification: new Audio(`../media/sounds/${user?.sound_notification?.filename || "macos_Tink.mp3"}`),
      sound_success: new Audio(`../media/sounds/${user?.sound_success?.filename || "notification_simple-02.mp3"}`),
      sound_error: new Audio(`../media/sounds/${user?.sound_error?.filename || "alert_error-03.mp3"}`),
      sound_email_sent: new Audio(`../media/sounds/${user?.sound_email_sent?.filename || "navigation_transition-left.mp3"}`),
    }),
    [user]
  );

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    dispatch(AlertReducer.actions.hideAlert());
  };

  const getAlertCodename = () => {
    switch (alert.severity) {
      case "info":
        return "sound_notification";
      case "error":
        return "sound_error";
      case "success":
        return "sound_success";
      case "warning":
        return "sound_notification";
      default:
        return "sound_notification";
    }
  };

  //
  useEffect(() => {
    if (user?.sound_enabled && alert.show) {
      const audioRef = sounds[alert.codename] || sounds[getAlertCodename()];
      if (audioRef) {
        audioRef.currentTime = 0; // Reset sound
        audioRef.play();
        setTimeout(() => {
          audioRef.pause();
          dispatch(SoundReducer.actions.stopSound());
        }, sound.duration || 3000);
      }
    }
  }, [alert, user, sounds]);

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{ vertical: alert.vertical, horizontal: alert.horizontal }}
        autoHideDuration={alert.duration}
        key={`${alert.vertical},${alert.horizontal}`}
        open={alert.show}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={alert.severity}>
          {alert.text}
        </Alert>
      </Snackbar>
    </div>
  );
}
